<template>
    <div class="login-page">
        <div class="wrapper wrapper-full-page">
        <div class="full-page login-page section-image">
            <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
            <div class="content">
            <div class="container">
                <div class="col-lg-6 col-md-6 ml-auto mr-auto">
                <form>
                    <card type="login">
                    <h3 slot="header" class="header text-center">Recupere su cuenta</h3>
                    <!--Sending state-->
                    <loading :active.sync="isSending"
                    :can-cancel="false" 
                    :is-full-page="fullPage">
                    </loading>
                    <!--./Sending state-->
                    <p>Ingrese el correo asociado a su cuenta</p>
                    <fg-input   v-model="model.email" 
                                addon-left-icon="nc-icon nc-single-02"
                                placeholder="Correo electrónico"
                                name="correo"
                                autocomplete="off"
                                v-validate="modelValidations.email"
                                :error="getError('correo')"></fg-input>
                    <br>
                    <div class="card-footer text-right">
                        <p-button @click="cancelForm" class="pull-left" slot="footer" type="default" round >Cancelar</p-button>
                        <p-button native-type="submit" @click.prevent="validate"  type="warning" round>Continuar</p-button>
                    </div>
                    </card>
                </form>
                </div>
            </div>
            </div>
            <div class="full-page-background" v-bind:style="loginBackground()"></div>
        </div>
        </div>
    </div>
    </template>
    <script>
    import swal from 'sweetalert2'
    import { Card, Checkbox, Button } from 'src/components/UIComponents';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { PASSWORD_RESET} from 'src/api/graphql/mutations/user/PasswordReset';
    import SecureLS from 'secure-ls'
    export default {
        components: {
        Card,
        Loading,
        [Checkbox.name]: Checkbox,
        [Button.name]: Button
        },
        methods: {
        cancelForm(){
        /*** 
        * Función que devuelve al formulario de login
        */
            this.$router.push('/login');
        },
        loginBackground(){
            return 'background-image: url('+process.env.VUE_APP_BASE_ROUTE+'img/login_background.jpg)';
        },
        toggleNavbar() {
            document.body.classList.toggle('nav-open')
        },
        closeMenu() {
            document.body.classList.remove('nav-open')
            document.body.classList.remove('off-canvas-sidebar')
        },
        /*** 
         * Función que permite visualizar los errores en cada campo del input
         */
        getError (fieldName) {
            return this.errors.first(fieldName)
        },
        /*** 
        * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro erróneo
        */
        onError(message){
            swal({
                title: `¡Alerta!`,
                text: message,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill',
                type: 'error'
            });
        },
        /*** 
        * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro exitoso
        */
        onSuccess(){
            var vm = this;
            swal({
                title: '¡Enviado!',
                text: 'Revisa tu correo electrónico y sigue los pasos',
                type: 'success',
                confirmButtonClass: 'btn btn-success btn-fill',
                buttonsStyling: false
            }).then(() => {
                vm.$router.push('/login');
            },function (dismiss){
                vm.$router.push('/login');
            });
        },
        /***
         * Función para validar el formulario de edición y creación que se envía
         */
        validate () {
            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    var vm = this;
                    vm.isSending = true;
                    var formInput = {
                            email: vm.model.email
                    };
                    // Iniciamos el envío de la mutación
                    this.$apollo.mutate({
                        mutation: PASSWORD_RESET,
                        variables : {
                            input : formInput
                        }
                    }).then((data) => {
                        vm.onSuccess();
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.onError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                    });
                }
            })
        }
        },
        data() {
            return {
                isSending: false,
                fullPage: false,
                model: {
                    email: '',
                },
                modelValidations: {
                    email: {
                        email: true,
                        required: true,
                        max: 64
                    },
                },
            }
        },
        mounted(){
        },
        beforeDestroy() {
        this.closeMenu();
        }
    }
</script>
<style>
</style>
